import {
  DSLValueLegacy,
  SubjectVariableCriteriaSelectionTypeLegacy,
  type CohortBuilderModelLegacy,
} from '@verantos-dev/types-cohorts';

import { getFullDslQueryString } from './adapters/getFullDslQueryString';
import { transformDerivedEventsToDsl } from './adapters/transformDerivedEventsToDsl';
import { transformIndexDateToDsl } from './adapters/transformIndexDateToDsl';
import { transformSimpleEventsToDsl } from './adapters/transformSimpleEventsToDsl';
import { transformStudyPeriodRestrictionsToDsl } from './adapters/transformStudyPeriodRestrictionsToDsl';
import { transformSubjectVariablesToDsl } from './adapters/transformSubjectVariablesToDsl';

/**
 * Generates a DSL query string from a cohort definition model.
 *
 * @param {CohortBuilderModel} cohortDefinition The cohort definition model
 * @returns {string} The DSL query string
 */
export const generateDSLFromUIModel = ({
  simpleEvents,
  derivedEvents,
  indexDate,
  subjectVariables,
  studyPeriodRestrictions,
}: CohortBuilderModelLegacy): string => {
  const simpleEventsDsl = transformSimpleEventsToDsl(simpleEvents);
  const derivedEventsDsl = transformDerivedEventsToDsl(derivedEvents);
  const indexDateDsl = indexDate ? transformIndexDateToDsl(indexDate) : undefined;
  const subjectVariablesDsl = transformSubjectVariablesToDsl(subjectVariables);
  const studyPeriodRestrictionsDsl = transformStudyPeriodRestrictionsToDsl(studyPeriodRestrictions);

  return getFullDslQueryString({
    simpleEvents: simpleEventsDsl,
    derivedEvents: derivedEventsDsl,
    indexDate: indexDateDsl,
    subjectVariables: subjectVariablesDsl,
    studyPeriodRestrictions: studyPeriodRestrictionsDsl,
    inclusionCriteria:
      subjectVariables.reduce((nextInclusionCriteria: DSLValueLegacy[], subjectVariable) => {
        if (
          subjectVariable.criteriaSelection === SubjectVariableCriteriaSelectionTypeLegacy.INCLUSION
        ) {
          nextInclusionCriteria.push({ id: subjectVariable.id, value: subjectVariable.name });
        }
        return nextInclusionCriteria;
      }, []) ?? [],
    exclusionCriteria:
      subjectVariables.reduce((nextInclusionCriteria: DSLValueLegacy[], subjectVariable) => {
        if (
          subjectVariable.criteriaSelection === SubjectVariableCriteriaSelectionTypeLegacy.EXCLUSION
        ) {
          nextInclusionCriteria.push({ id: subjectVariable.id, value: subjectVariable.name });
        }
        return nextInclusionCriteria;
      }, []) ?? [],
  });
};
